const joinClassNames = ( ...classNames ) => classNames.join(' ')
export default joinClassNames